export default "__VITE_ASSET__CVFR75ON__"